"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sissa-trecasali": {
    "b527883a": [{
      "hkey": "168c6925",
      "slug": "sissa-trecasali",
      "name": "Sissa Trecasali",
      "primary": true,
      "skipSearch": false
    }],
    "isola-jesus": [{
      "hkey": "168c6925",
      "slug": "sissa-trecasali",
      "name": "Sissa Trecasali",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ab0bcc33": [{
      "hkey": "fa84d2cc",
      "slug": "ronco-campo-canneto",
      "name": "Ronco Campo Canneto",
      "primary": true,
      "skipSearch": false
    }],
    "ronco-campo-canneto-e-viarolo": [{
      "hkey": "fa84d2cc",
      "slug": "ronco-campo-canneto",
      "name": "Ronco Campo Canneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "64ae7c37": [{
      "hkey": "168c6925",
      "slug": "sissa-trecasali",
      "name": "Sissa Trecasali",
      "primary": true,
      "skipSearch": false
    }],
    "sala": [{
      "hkey": "168c6925",
      "slug": "sissa-trecasali",
      "name": "Sissa Trecasali",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;